import { render } from "./ViewAds.vue?vue&type=template&id=6b17cd85&scoped=true"
import script from "./ViewAds.vue?vue&type=script&lang=js"
export * from "./ViewAds.vue?vue&type=script&lang=js"

import "./ViewAds.vue?vue&type=style&index=0&id=6b17cd85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b17cd85"]])

export default __exports__